import React from 'react';
import { ORDER_PREFERENCES_PREFIX } from './orderWorkspacePreferences';

/**
 * 缓存清除工具
 * 用于处理部署后的缓存问题
 */

// 版本信息检查和缓存清除
export const checkVersionAndClearCache = () => {
  try {
    // 获取当前版本信息
    const currentVersion = getCurrentVersionInfo();
    const storedVersion = localStorage.getItem('app_version');

    // 如果版本不同，清除缓存
    if (currentVersion && storedVersion !== currentVersion.buildTime) {
      console.log('🔄 检测到新版本，正在清除缓存...');

      // 清除localStorage中的缓存数据
      clearAppCache();

      // 存储新版本信息
      localStorage.setItem('app_version', currentVersion.buildTime);

      return true; // 表示检测到新版本
    }

    return false; // 未检测到新版本
  } catch (error) {
    console.warn('版本检查失败:', error);
    return false;
  }
};

// 获取当前版本信息
export const getCurrentVersionInfo = () => {
  const versionMeta = document.querySelector('meta[name="build-time"]');
  const buildVersion = document.querySelector('meta[name="build-version"]');
  const buildCommit = document.querySelector('meta[name="build-commit"]');

  if (versionMeta) {
    return {
      buildTime: versionMeta.getAttribute('content'),
      version: buildVersion?.getAttribute('content') || '1.0.0',
      commit: buildCommit?.getAttribute('content') || '',
    };
  }

  return null;
};

// 清除应用缓存
const clearAppCache = () => {
  try {
    // 清除除用户认证信息外的localStorage数据
    const keysToKeep = ['token', 'user']; // 保留用户登录信息
    const allKeys = Object.keys(localStorage);

    allKeys.forEach((key) => {
      if (!keysToKeep.includes(key) && !key.startsWith(ORDER_PREFERENCES_PREFIX)) {
        localStorage.removeItem(key);
      }
    });

    // 清除sessionStorage
    sessionStorage.clear();

    console.log('✅ 应用缓存已清除');
  } catch (error) {
    console.warn('清除缓存时出错:', error);
  }
};

// 强制刷新页面（清除所有缓存）
export const forceRefresh = () => {
  const timestamp = Date.now();
  const url = new URL(window.location);
  url.searchParams.set('v', timestamp);
  window.location.href = url.toString();
};

// 版本检查hook
export const useVersionCheck = () => {
  const [hasNewVersion, setHasNewVersion] = React.useState(false);

  React.useEffect(() => {
    const newVersionDetected = checkVersionAndClearCache();
    setHasNewVersion(newVersionDetected);
  }, []);

  return { hasNewVersion, forceRefresh };
};

const cacheBuster = {
  checkVersionAndClearCache,
  getCurrentVersionInfo,
  forceRefresh,
  useVersionCheck,
};

export default cacheBuster;
